import React from 'react';
import {
    Box,
    Center,
    Heading,
    SimpleGrid,
    GridItem,
    Grid,
    Flex,
    Stack,
    Text,
    useColorModeValue as mode,
    Input,
    useMediaQuery,
    ModalCloseButton,
    FormLabel,
    ModalFooter,
    Img,
    Button, Wrap, WrapItem,
  } from "@chakra-ui/react";
import { textStyle } from 'theme/names';


export const SocialProof = ({}) => {

    const [isTooSmall] = useMediaQuery("(max-width: 1000px)");

    return (
        <>
            {
                !isTooSmall && (
                // true && (

                    <Box m={14} display="flex" alignItems="center" justifyContent="center">
                        <Text textStyle={textStyle.body.medium.standard}
                            fontWeight="600"
                            fontSize="24px"
                            mr={5}
                        >
                            Join
                        </Text>
                        <Wrap>
                            {
                                [
                                    // {src: "/proof/5harath.jpg"},
                                    {src: "/proof/aaditsh.png"},
                                    {src: "/proof/AlexLlullTW.png"},
                                    {src: "/proof/arvidkahl.png"},
                                    {src: "/proof/creation247.png"},
                                    {src: "/proof/heyblake.png"},
                                    {src: "/proof/writingtoriches.png"},
                                    {src: "/proof/IAmAaronWill.png"},
                                    {src: "/proof/jmoserr.png"},
                                    {src: "/proof/thedankoe.png"},
                                    {src: "/proof/Prathkum.png"},
                                    {src: "/proof/OneJKMolina.png"},
                                ].map((img, index) => {
                                    return (
                                        <WrapItem key={index}>
                                            <Img
                                                w="10"
                                                h="10"
                                                rounded="3xl"
                                                objectFit="cover"
                                                src={img.src}
                                                alt="Chakra UI"
                                                mr={1}
                                                // ml={2}
                                            />
                                        </WrapItem>
                                    )
                                })
                            }
                        </Wrap>
                        <Text textStyle={textStyle["body.medium.light"]}
                            ml={3}
                            fontWeight="600"
                            fontSize="24px"
                        >
                            and over 1,500+ others
                        </Text>
                    </Box>
                )
            }
        </>
    );
}